<h4 class="mt-4">Autotransporte</h4>
    <mat-grid-list cols="2" rowHeight="100px" height="400px">
        <mat-grid-tile>
                <mat-form-field appearance="fill" [formGroup]="FormTransporte">
                    <mat-label>Seleccione autotransporte</mat-label>
                    <mat-select formControlName="idATransporte" (selectionChange)="asign($event.value)">
                        <mat-option *ngFor="let autotransporte of autotransportes" [value]="autotransporte">
                        {{autotransporte.nombre}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <button class="fuse-mat-button-rounded mgbutton" mat-flat-button [disabled]="(this.FormTransporte.value.idATransporte <= 0)" (click)="deleteTransporte()">Eliminar</button>
            <button class="fuse-mat-button-rounded mgbutton" mat-flat-button [disabled]="(this.FormTransporte.invalid)" (click)="saveOrUpdateTransporte()" [color]="'primary'">Guardar</button>
        </mat-grid-tile>
    </mat-grid-list>
    
    <div class="row">
        <div class="col-sm-12">
            <hr>
        </div>
    </div>
    
    <div class="row ">
        <div class="col-sm-4">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                <mat-label>Nombre del autotransporte</mat-label>
                <input matInput formControlName="nombre">
            </mat-form-field>
        </div>
        <div class="col-sm-4">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                <mat-label>PermSCT</mat-label>
                <mat-select name="PermSCT" formControlName="PermSCT">
                    <mat-option *ngFor="let cat of catPermSCT" [value]="cat?.id">
                        {{cat?.attributes?.clave}} - {{cat?.attributes?.nombre}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="(FormTransporte.get('PermSCT').invalid && FormTransporte.get('PermSCT').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-4">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                <mat-label>NumPermisoSCT </mat-label>
                <input matInput formControlName="NumPermisoSCT">
                <mat-error *ngIf="(FormTransporte.get('NumPermisoSCT').invalid && FormTransporte.get('NumPermisoSCT').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <!--Idenficacion vehicular-->
    <div class="row border mt-4">
        <h5 class="col-sm-12">Identificacion Vehicular</h5>
        <div class="col-sm-6">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                <mat-label>ConfigVehicular </mat-label>
                <mat-select formControlName="ConfigVehicular">
                    <mat-option *ngFor="let confVeh of catConfigVehicular" [value]="confVeh?.id">{{ confVeh?.attributes?.nombre }}</mat-option>
                </mat-select>
                <mat-error *ngIf="(FormTransporte.get('ConfigVehicular').invalid && FormTransporte.get('ConfigVehicular').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                <mat-label>PlacaVM </mat-label>
                <input matInput formControlName="PlacaVM">
                <mat-error *ngIf="(FormTransporte.get('PlacaVM').invalid && FormTransporte.get('PlacaVM').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                <mat-label>AnioModeloVM</mat-label>
                <input type="text" minlength="4" maxlength="4" name="AnioModeloVM" matInput
                    formControlName="AnioModeloVM">
                    <mat-error *ngIf="(f['AnioModeloVM'].errors?.['required'] && FormTransporte.get('AnioModeloVM').touched)">
                        Campo requerido
                    </mat-error>
                <mat-error *ngIf="(f['AnioModeloVM'].errors?.['pattern'])">
                    Ingrese un valo válido
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <!--Idenficacion vehicular-->
    <div class="row border mt-4">
        <h5 class="col-sm-12">Seguros</h5>
            <div class="col-sm-3">
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                    <mat-label>AseguraRespCivil </mat-label>
                    <input matInput formControlName="AseguraRespCivil">
                    <mat-error *ngIf="(FormTransporte.get('AseguraRespCivil').invalid && FormTransporte.get('AseguraRespCivil').touched)">
                        Campo requerido
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-sm-3">
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                    <mat-label>PolizaRespCivil </mat-label>
                    <input matInput formControlName="PolizaRespCivil">
                    <mat-error *ngIf="(FormTransporte.get('PolizaRespCivil').invalid && FormTransporte.get('PolizaRespCivil').touched)">
                        Campo requerido
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-sm-3">
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                    <mat-label>AseguraMedAmbiente</mat-label>
                    <input matInput formControlName="AseguraMedAmbiente">
                </mat-form-field>
            </div>
        
            <div class="col-sm-3">
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                    <mat-label>PolizaMedAmbiente</mat-label>
                    <input matInput formControlName="PolizaMedAmbiente">
                </mat-form-field>
            </div>
            <div class="col-sm-3">
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                    <mat-label>AseguraCarga </mat-label>
                    <input matInput formControlName="AseguraCarga">
                </mat-form-field>
            </div>
            <div class="col-sm-3">
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                    <mat-label>PolizaCarga</mat-label>
                    <input matInput formControlName="PolizaCarga">
                </mat-form-field>
            </div>

            <div class="col-sm-3">
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                    <mat-label>PrimaSeguro</mat-label>
                    <input matInput formControlName="PrimaSeguro" type="number">
                </mat-form-field>
            </div>

    </div>
    